export const getAllDriversData = ({ state }) => state.drivers.driversData;
export const getIsExporting = ({ state }) => state.drivers.isExporting;
